<template>
  <PbHeader class="pb-default-header">
    <template v-if="$route.name !== routeNames.Error && translationsLoaded">
      <ControlButton
        v-if="$route.name !== routeNames.Create"
        :tooltip="full ? null : translate('pb2.defaultHeader.createProfile')"
        :to="{ name: routeNames.Create }"
        :label="full ? translate('pb2.defaultHeader.createProfile') : null"
        :aria-label="full ? null : translate('pb2.defaultHeader.createProfile')"
        :icon="full ? null : 'icon-add'"
        class="pb-default-header-link"
      />
      <ControlButton
        v-if="$route.name !== routeNames.Import"
        :tooltip="translate('pb2.defaultHeader.importProfile')"
        :to="{ name: routeNames.Import }"
        class="pb-default-header-link"
        :aria-label="translate('pb2.defaultHeader.importProfile')"
        icon="icon-upload"
      />
    </template>
  </PbHeader>
</template>

<script setup>
import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'
import PbHeader from '@/components/PbHeader/PbHeader.vue'
import routeNames from '@/router/names'
import useTranslate from '@/composables/useTranslate'
import useDevice from '@nicolaudie-group/ng-ui-kit/composables/useDevice'

const { translate, translationsLoaded } = useTranslate()

const { isBiggerThanMobile: full } = useDevice()
</script>

<style lang="scss" src="./DefaultHeader.scss" />
